<template>
  <app-button
    :disabled="disabled || isLoading"
    data-qa="download-change-order-pdf-button"
    @click="download"
  >
    {{ i18n.t('/change-order/actions/download-pdf') }}
    <loader v-if="isLoading" />
  </app-button>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import Pdf from '@/api/server/Pdf.api'
import { saveAs } from 'file-saver'

export default {
  components: {
    AppButton,
    Loader,
  },
  props: {
    changeOrderId: {
      type: String,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonClass: {
      type: String,
      default: 'inverted--bordered',
    },
  },
  data() {
    return {
      isLoading: false,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  methods: {
    async download() {
      try {
        this.isLoading = true
        const data = await Pdf.GetChangeOrderPdf(this.changeOrderId)
        saveAs(data.pdfContent, data.fileName)
      } catch (e) {
        return Promise.reject(e)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style></style>
